import { useState, useMemo, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProductCard from "@/components/ProductCard";
import CategoryFilter from "@/components/CategoryFilter";
import { products } from "@/data/products";

const Index = () => {
  const [searchParams] = useSearchParams();
  const initialCat = searchParams.get("categoria") || "Todos";
  const [activeCategory, setActiveCategory] = useState(initialCat);

  useEffect(() => {
    const setMeta = (selector: string, content: string) => {
      const meta = document.querySelector<HTMLMetaElement>(selector);
      if (meta) {
        meta.setAttribute("content", content);
      }
    };

    document.title = "Ragazza";
    setMeta('meta[name="description"]', "Catalogo de productos Ragazza.");
    setMeta('meta[property="og:title"]', "Ragazza");
    setMeta('meta[property="og:description"]', "Catalogo de productos Ragazza.");
  }, []);

  const filtered = useMemo(
    () =>
      activeCategory === "Todos"
        ? products
        : products.filter((p) => p.category === activeCategory),
    [activeCategory]
  );

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1 bg-background">
        {/* Hero */}
        <section className="container mx-auto px-4 sm:px-6 pt-12 pb-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-display font-medium tracking-tight max-w-xl">
            Elegance in Every Step
          </h1>
        </section>

        {/* Filter + Grid */}
        <section className="container mx-auto px-4 sm:px-6 pb-16">
          <CategoryFilter active={activeCategory} onChange={setActiveCategory} />

          <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-8 sm:gap-x-6 sm:gap-y-10">
            {filtered.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>

          {filtered.length === 0 && (
            <p className="text-center text-muted-foreground py-16">
              No hay productos en esta categoría.
            </p>
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Index;
